import { render, staticRenderFns } from "./PcVipUpgradeComponent.vue?vue&type=template&id=a1f7d48e&scoped=true"
import script from "./PcVipUpgradeComponent.vue?vue&type=script&lang=js"
export * from "./PcVipUpgradeComponent.vue?vue&type=script&lang=js"
import style0 from "./PcVipUpgradeComponent.vue?vue&type=style&index=0&id=a1f7d48e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f7d48e",
  null
  
)

export default component.exports